import React from 'react';
import PageContainer from '../layout/PageContainer';
import OperacionesLiquidacionCredito from './OperacionesLiquidacionCredito';

const OperacionesLiquidacionCreditoContainer = () => {
  const breadcrumbs = [
    { id: 0, name: 'SEGURO DE CR\u00C9DITO', url: '/' },
    { id: 1, name: 'OPERACIONES', url: '/operaciones/liquidaciones-credito' },
    { id: 2, name: 'LIQUIDACIONES CR\u00C9DITO' },
  ];

  return (
    <PageContainer breadcrumbs={breadcrumbs}>
      <OperacionesLiquidacionCredito />
    </PageContainer>
  );
};

export default OperacionesLiquidacionCreditoContainer;
